// Pure helper for the sidebar menu: which entry a URL belongs to. No Angular imports, so it runs
// under `tsx --test` (menu-url.utils.test.ts); MenuService wraps it with the real MENU_ITEMS.

export interface MenuLinkItem {
    id: string;
    link?: string;
    children?: ReadonlyArray<{ id: string; link: string; activeUrls?: string[] }>;
}

/** The entry whose link (or extra active URL) is the longest prefix of the path, or null. */
export function menuIdForUrl(url: string, items: readonly MenuLinkItem[]): string | null {
    const path = String(url ?? '').split(/[?#]/)[0];
    let best: { id: string; link: string } | null = null;
    const consider = (id: string, link: string): void => {
        if (path !== link && !path.startsWith(`${link}/`)) return;
        if (best === null || link.length > best.link.length) best = { id, link };
    };
    for (const item of items) {
        if (item.link) consider(item.id, item.link);
        for (const child of item.children ?? []) {
            consider(child.id, child.link);
            for (const extra of child.activeUrls ?? []) consider(child.id, extra);
        }
    }
    const match: { id: string; link: string } | null = best;
    return match ? match.id : null;
}
